import { GetTaskResponseDetailsModel } from '@/types';

export interface CreateAuditTaskRequestModel {
  payload: {
    TransmissionHeader: {
      TransmissionDateTime: string;
      OriginatingSystem: string;
      TransmissionUser: string;
      RoutingCode: string;
      MessageType: string;
      MessageId: string;
    };
    Body: {
      OrgId: string;
      UpdateTaskDetails: CreateAuditTaskUpdateTaskDetails;
      StopOnFirstActionError: string;
    };
  };
  TraceData: {
    User: string;
    Plant: string;
    SessionId: string;
  };
}

export interface CreateAuditTaskUpdateTaskDetails {
  _trailerName: string;
  _carrierName: string;
  OrgId: string;
  UserId: string;
  ActionType: string;
  TaskType: string;
  AuditLocationName: string;
  AuditLocationZone: string;
  AuditLocationType: string;
  TrailerName: string;
  CarrierName: string;
  CarrierCode: string;
  ExceptionCode: string;
  AlternateTrailerValid: string;
  AlternateCarrierCode: string;
  AlternateTrailerName: string;
  AuditLocation: string;
  FilterType: string;
  LastAuditTime: string;
  TrailerComments: string;
}

export function mapUpdateTask(raw: CreateAuditTaskRequestModel): CreateAuditTaskRequest {
  return {
    payload: {
      TransmissionHeader: {
        TransmissionDateTime: raw.payload.TransmissionHeader.TransmissionDateTime,
        OriginatingSystem: raw.payload.TransmissionHeader.OriginatingSystem,
        TransmissionUser: raw.payload.TransmissionHeader.TransmissionUser,
        RoutingCode: raw.payload.TransmissionHeader.RoutingCode,
        MessageType: raw.payload.TransmissionHeader.MessageType,
        MessageId: raw.payload.TransmissionHeader.MessageId,
      },
      Body: {
        Org_id: raw.payload.Body.OrgId,
        Update_task_details: [
          {
            Org_id: raw.payload.Body.UpdateTaskDetails.OrgId,
            User_id: raw.payload.Body.UpdateTaskDetails.UserId,
            Action_type: raw.payload.Body.UpdateTaskDetails.ActionType,
            Task_type: raw.payload.Body.UpdateTaskDetails.TaskType,
            Audit_Location_Name: raw.payload.Body.UpdateTaskDetails.AuditLocationName,
            Trailer_name: raw.payload.Body.UpdateTaskDetails.TrailerName,
            Carrier_code: raw.payload.Body.UpdateTaskDetails.CarrierCode,
            Exception_code: raw.payload.Body.UpdateTaskDetails.ExceptionCode,
            Alternate_trailer_valid: raw.payload.Body.UpdateTaskDetails.AlternateTrailerValid,
            Alternate_carrier_code: raw.payload.Body.UpdateTaskDetails.AlternateCarrierCode,
            Alternate_trailer_name: raw.payload.Body.UpdateTaskDetails.AlternateTrailerName,
            Trailer_comments: raw.payload.Body.UpdateTaskDetails.TrailerComments,
          },
        ],
        Stop_on_first_action_error: raw.payload.Body.StopOnFirstActionError,
      },
    },
    TraceData: {
      User: raw.TraceData.User,
      Plant: raw.TraceData.Plant,
      SessionId: raw.TraceData.SessionId,
    },
  };
}

export interface CreateAuditTaskRequest {
  payload: {
    TransmissionHeader: {
      TransmissionDateTime: string;
      OriginatingSystem: string;
      TransmissionUser: string;
      RoutingCode: string;
      MessageType: string;
      MessageId: string;
    };
    Body: {
      Org_id: string;
      Update_task_details: [
        {
          Org_id: string;
          User_id: string;
          Action_type: string;
          Task_type: string;
          Audit_Location_Name: string;
          Trailer_name: string;
          Carrier_code: string;
          Exception_code: string;
          Alternate_trailer_valid: string;
          Alternate_carrier_code: string;
          Alternate_trailer_name: string;
          Trailer_comments: string;
        },
      ];
      Stop_on_first_action_error: string;
    };
  };
  TraceData: {
    User: string;
    Plant: string;
    SessionId: string;
  };
}
export interface LocationList {
  LocStatus: string;
  TrailerName: string;
  CarrierName: string;
  CarrierCode: string;
  LastAuditTime: string;
}

export interface GetLocationListResponseModel {
  Success: string;
  Message: string;
  MessageKey: string;
  NumRecords: number;
  Locations: {
    _locStatus: string;
    LocStatus: string;
    TrailerName: string;
    CarrierName: string;
    CarrierCode: string;
    LastAuditTime: string;
  };
}

export interface AuditTrailerItem {
  CarrierScac: string;
  TrailerName: string;
  CarrierName: string;
  locationname: string;
  locationzone: string;
}

export interface AuditLocationDetail {
  LocationName: string;
  LocationZone: string;
  LocationType: string;
  LocStatus: string;
  TrailerName: string;
  CarrierName: string;
  CarrierCode: string;
  LastAuditTime: string;
}
export interface UpdateTaskResponseTaskDetails {
  Action_code: string;
  Org_id: string;
  Task_id: string;
  Task_type: string;
  Status: string;
  Assigned_user_id: string;
  Created_source: string;
  Created_datetime: string;
  Last_updated_datetime: string;
  Last_updated_source: string;
  Priority: string;
  Yard_id: string;
  Task_start_datetime: string;
  Task_end_datetime: string;
  Task_release_datetime: string;
  Task_comments: string;
  Trailer_id: string;
  Trailer_name: string;
  Trailer_comments: string;
  Carrier_company_name: string;
  Carrier_name: string;
  Audit_location_type: string;
  Audit_location_zone: string;
  Audit_location_name: string;
  Move_src_type: string;
  Move_src_zone: string;
  Move_src_name: string;
  Move_dst_type: string;
  Move_dst_zone: string;
  Move_dst_name: string;
  Exception_code: string;
  Elapsed_time: string;
  Task_assigned_time: string;
  Alt_Dst_Zone: string;
  Alt_Dst_Name: string;
  Alt_Trailer_Valid: string;
  Alt_Carrier: string;
  Alt_Trailer: string;
}

export interface UpdateTaskResponseUpdateTaskDetail {
  Status: string;
  Status_message: string;
  Status_code: string;
  Task_details: UpdateTaskResponseTaskDetails;
  Org_id: string;
  Task_id: string;
  Task_type: string;
  User_id: string;
  Action_type: string;
  Action_datetime: string;
  Trailer_name: string;
  Carrier_name: string;
  Exception_code: string;
  Task_comments: string;
  Trailer_comments: string;
  TaskStartedDateTime: string;
  SelectedIndex: number;
  CurrentLoggedInUser: string;
  AlternateTrailerValid: string;
  AlternateCarrier: string;
  AlternateTrailerName: string;
  AlternateDestinationZone: string;
  AlternateDestinationName: string;
  OverrideReasonCode: string;
  TaskCommentOverrideReasonCode: string;
}

export interface CreateAuditResponse {
  payload: {
    TransmissionHeader: {
      TransmissionDateTime: string;
      OriginatingSystem: string;
      TransmissionUser: string;
      RoutingCode: string;
      MessageType: string;
      MessageId: string;
    };
    Body: {
      Status: string;
      Status_message: string;
      Status_code: string;
      Update_task_details?: UpdateTaskResponseUpdateTaskDetail[];
    };
  };
}

export interface CompleteActionExceptionItem {
  code: string;
  text: string;
}

export interface CompleteActionException {
  move: CompleteActionExceptionItem[];
  audit: CompleteActionExceptionItem[];
  audit_without_trailer: CompleteActionExceptionItem[];
}

export type QuestionSelection = 'NotSelected' | 'Yes' | 'No';

export interface QuestionModel {
  Question: string;
  QuestionType: string;
  YesOption: QuestionModel | null;
  NoOption: QuestionModel | null;
  QuestionSelection: QuestionSelection;
}

export interface QuestionFlow {
  move: QuestionModel;
  audit: QuestionModel;
  audit_without_trailer: QuestionModel;
  fix: QuestionModel;
  fix_without_trailer: QuestionModel;
}

export interface TaskSummaryRequestDTO {
  Org: string;
  Start_time: string;
  End_time: string;
  User_id: string;
}

export interface RequestTraceDataDTO {
  User: string;
  Plant: string;
  SessionId: string;
}

export interface TaskSummaryResponseDTO {
  payload: {
    TransmissionHeader: {
      TransmissionDateTime: string;
      OriginatingSystem: string;
      TransmissionUser: string;
      RoutingCode: string;
      MessageType: string;
    };
    Body: {
      Status: string;
      Status_message: string;
      Status_code: string;
      Num_of_records: string;
      Num_of_critical: string;
      Num_of_urgent: string;
      Num_of_audits: string;
      Num_of_moves: string;
      Task?: TaskSummaryDTO;
    };
  };
}

export interface TaskSummaryDTO {
  Task_details: GetTaskResponseTaskDetailDTO[];
}

export interface GetTaskResponseTaskDetailDTO {
  Action_code: string;
  Org_id: string;
  Task_id: string;
  Task_type: string;
  Status: string;
  Assigned_user_id: string;
  Created_source: string;
  Created_datetime: string;
  Last_updated_datetime: string;
  Last_updated_source: string;
  Priority: string;
  Yard_id: string;
  Task_start_datetime: string;
  Task_end_datetime: string;
  Task_release_datetime: string;
  Task_comments: string;
  Trailer_id: string;
  Trailer_name: string;
  Trailer_comments: string;
  Carrier_company_name: string;
  Carrier_name: string;
  Audit_locn_type: string;
  Audit_locn_zone: string;
  Audit_locn_name: string;
  Move_src_type: string;
  Move_src_zone: string;
  Move_src_name: string;
  Move_dst_type: string;
  Move_dst_zone: string;
  Move_dst_name: string;
  Exception_code: string;
  Elapsed_time: string;
  Task_assigned_time: string;
  Alt_Trailer_Valid: string;
  Alt_Carrier: string;
  Alt_trailer_name: string;
  Alt_Dst_Zone: string;
  Alt_Dst_Name: string;
}

export interface TaskSummaryModel {
  payload: {
    TransmissionHeader: {
      TransmissionDateTime: string;
      OriginatingSystem: string;
      TransmissionUser: string;
      RoutingCode: string;
      MessageType: string;
    };
    Body: {
      Status: string;
      StatusMessage: string;
      StatusCode: string;
      NumOfRecords: string;
      NumOfCritical: string;
      NumOfUrgent: string;
      NumOfMoves: string;
      NumOfAudits: string;
      Task: TaskSummary;
    };
  };
}

export interface TaskSummaryDetailItem {
  ActionCode: string;
  OrgId: string;
  TaskId: string;
  TaskType: string;
  Status: string;
  AssignedUserId: string;
  CreatedSource: string;
  CreatedDatetime: string;
  LastUpdatedDatetime: string;
  LastUpdatedSource: string;
  Priority: string;
  YardId: string;
  TaskStartDatetime: string;
  TaskEndDatetime: string;
  TaskReleaseDatetime: string;
  TaskComments: string;
  TrailerId: string;
  TrailerName: string;
  TrailerComments: string;
  CarrierCompanyName: string;
  CarrierName: string;
  AuditLocationType: string;
  AuditLocationZone: string;
  AuditLocationName: string;
  MoveSourceType: string;
  MoveSourceZone: string;
  MoveSourceName: string;
  MoveDestinationType: string;
  MoveDestinationZone: string;
  MoveDestinationName: string;
  DisplayCreatedDatetime: string;
  DisplayLastUpdatedDatetime: string;
  ExceptionCode: string;
  TaskAssignedTime: string;
  TaskDescription: string;
}
export interface TaskSummary {
  TaskDetails: TaskSummaryDetailItem[];
}

export function mapTaskSummaryRes(raw: TaskSummaryResponseDTO): TaskSummaryModel {
  return {
    payload: {
      TransmissionHeader: {
        TransmissionDateTime: raw.payload.TransmissionHeader.TransmissionDateTime,
        OriginatingSystem: raw.payload.TransmissionHeader.OriginatingSystem,
        TransmissionUser: raw.payload.TransmissionHeader.TransmissionUser,
        RoutingCode: raw.payload.TransmissionHeader.RoutingCode,
        MessageType: raw.payload.TransmissionHeader.MessageType,
      },
      Body: {
        Status: raw.payload.Body.Status,
        StatusMessage: raw.payload.Body.Status_message,
        StatusCode: raw.payload.Body.Status_code,
        NumOfRecords: raw.payload.Body.Num_of_records,
        NumOfCritical: raw.payload.Body.Num_of_critical,
        NumOfUrgent: raw.payload.Body.Num_of_urgent,
        NumOfAudits: raw.payload.Body.Num_of_audits,
        NumOfMoves: raw.payload.Body.Num_of_moves,
        Task: {
          TaskDetails: (raw.payload.Body.Task?.Task_details ?? []).map((detail) => ({
            ActionCode: detail.Action_code,
            OrgId: detail.Org_id,
            TaskId: detail.Task_id,
            TaskType: detail.Task_type,
            Status: detail.Status,
            AssignedUserId: detail.Assigned_user_id,
            CreatedSource: detail.Created_source,
            CreatedDatetime: detail.Created_datetime,
            LastUpdatedDatetime: detail.Last_updated_datetime,
            LastUpdatedSource: detail.Last_updated_source,
            Priority: detail.Priority,
            YardId: detail.Yard_id,
            TaskStartDatetime: detail.Task_start_datetime,
            TaskEndDatetime: detail.Task_end_datetime,
            TaskReleaseDatetime: detail.Task_release_datetime,
            TaskComments: detail.Task_comments,
            TrailerId: detail.Trailer_id,
            TrailerName: detail.Trailer_name,
            TrailerComments: detail.Trailer_comments,
            CarrierCompanyName: detail.Carrier_company_name,
            CarrierName: detail.Carrier_name,
            AuditLocationType: detail.Audit_locn_type,
            AuditLocationZone: detail.Audit_locn_zone,
            AuditLocationName: detail.Audit_locn_name,
            MoveSourceType: detail.Move_src_type,
            MoveSourceZone: detail.Move_src_zone,
            MoveSourceName: detail.Move_src_name,
            MoveDestinationType: detail.Move_dst_type,
            MoveDestinationZone: detail.Move_dst_zone,
            MoveDestinationName: detail.Move_dst_name,
            ExceptionCode: detail.Exception_code,
            TaskAssignedTime: detail.Task_assigned_time,
            DisplayCreatedDatetime: '',
            DisplayLastUpdatedDatetime: '',
            TaskDescription: '',
          })),
        },
      },
    },
  };
}

export interface GetTaskResponseDTO {
  payload: {
    TransmissionHeader: {
      TransmissionDateTime: string;
      OriginatingSystem: string;
      TransmissionUser: string;
      RoutingCode: string;
      MessageType: string;
      MessageId: string;
    };
    Body: {
      Status: string;
      Status_message: string;
      Status_code: string;
      Num_of_records: string;
      Task?: TaskSummaryDTO;
    };
  };
}

export function mapTaskListRes(raw: GetTaskResponseDTO): GetTaskResponseDetailsModel {
  return {
    Payload: {
      TransmissionHeader: {
        TransmissionDateTime: raw.payload.TransmissionHeader.TransmissionDateTime,
        OriginatingSystem: raw.payload.TransmissionHeader.OriginatingSystem,
        TransmissionUser: raw.payload.TransmissionHeader.TransmissionUser,
        RoutingCode: raw.payload.TransmissionHeader.RoutingCode,
        MessageType: raw.payload.TransmissionHeader.MessageType,
        MessageId: raw.payload.TransmissionHeader.MessageId,
      },
      Body: {
        Status: raw.payload.Body.Status,
        StatusMessage: raw.payload.Body.Status_message,
        StatusCode: raw.payload.Body.Status_code,
        NumberOfRecords: raw.payload.Body.Num_of_records,
        Task: {
          TaskDetails: (raw.payload.Body.Task?.Task_details ?? []).map((detail) => ({
            ActionCode: detail.Action_code,
            OrgId: detail.Org_id,
            TaskId: detail.Task_id,
            TaskType: detail.Task_type,
            Status: detail.Status,
            AssignedUserId: detail.Assigned_user_id,
            CreatedSource: detail.Created_source,
            CreatedDatetime: detail.Created_datetime,
            LastUpdatedDatetime: detail.Last_updated_datetime,
            LastUpdatedSource: detail.Last_updated_source,
            Priority: detail.Priority,
            PriorityName: '',
            YardId: detail.Yard_id,
            TaskStartDateTime: detail.Task_start_datetime,
            TaskEndDateTime: detail.Task_end_datetime,
            TaskReleaseDatetime: detail.Task_release_datetime,
            TaskComments: detail.Task_comments,
            TrailerId: detail.Trailer_id,
            TrailerName: detail.Trailer_name,
            TrailerComments: detail.Trailer_comments,
            CarrierCompanyName: detail.Carrier_company_name,
            CarrierName: detail.Carrier_name,
            AuditLocationType: detail.Audit_locn_type,
            AuditLocationZone: detail.Audit_locn_zone,
            AuditLocationName: detail.Audit_locn_name,
            MoveSourceType: detail.Move_src_type,
            MoveSourceZone: detail.Move_src_zone,
            MoveSourceName: detail.Move_src_name,
            MoveDestinationType: detail.Move_dst_type,
            MoveDestinationZone: detail.Move_dst_zone,
            MoveDestinationName: detail.Move_dst_name,
            CurrentLoggedInUser: '',
            ElapsedTime: detail.Elapsed_time,
            ExceptionCode: detail.Exception_code,
            ExceptionText: '',
            TaskAssignedTime: detail.Task_assigned_time,
            AlternateTrailerValid: detail.Alt_Trailer_Valid,
            AlternateCarrier: detail.Alt_Carrier,
            AlternateTrailerName: detail.Alt_trailer_name,
            AlternateDestinationZone: detail.Alt_Dst_Zone,
            AlternateDestinationName: detail.Alt_Dst_Name,
            TaskDescription: '',
          })),
        },
      },
    },
  };
}
